import { Loader, LoaderOptions } from "google-maps";
import mapping from "../../plugins/jquery.mapping.js";

const options = "";
const loader = new Loader("AIzaSyAy95f7wv6028ee2Nz48THlsQ7ty9SVhIg", options);

const featureMarkerData = [];
const featureMarkerIcon = [];
const pastMarkerData = [];
const pastMarkerIcon = [];
const featureMarker = [];
const pastMarker = [];

$(".js-featureMap .top-map-list__item").each(function (i, v) {
  if (!$(v).data("place")) {
    return;
  }
  featureMarkerData.push({
    lat: $(v).data("place")[0],
    lng: $(v).data("place")[1],
    icon:
      "./assets/img/top/pin/pin-" + (i === 0 ? "on-" : "off-") + 
      (768 <= $(window).width() ? $(v).data("id") + "-pc.svg" :  $(v).data("id") + "-sp.svg"),
    zIndex: (i === 0 ? 100 : 50),
    click: function () {
      // openInfoWindow($(v))
    },
  });
  featureMarkerIcon.push({
    icon:
      "./assets/img/top/pin/pin-" +
      (768 <= $(window).width()
        ? "off-" + $(v).data("id") + "-pc.svg"
        : "off-" + $(v).data("id") + "-sp.svg"),
  });
});

// $(".js-pastMap .top-map-list__item").each(function (i, v) {
//   if (!$(v).data("place")) {
//     return;
//   }
//   pastMarkerData.push({
//     lat: $(v).data("place")[0],
//     lng: $(v).data("place")[1],
//     icon:
//       "./assets/img/top/pin/pin-" + (i === 0 ? "on-" : "off-") + 
//       (768 <= $(window).width() ? $(v).data("id") + "-pc.svg" :  $(v).data("id") + "-sp.svg"),
//     zIndex: (i === 0 ? 100 : 50),
//     click: function () {
//       // openInfoWindow($(v))
//     },
//   });
//   pastMarkerIcon.push({
//     icon:
//       "./assets/img/top/pin/pin-" +
//       (768 <= $(window).width()
//         ? "off-" + $(v).data("id") + "-pc.svg"
//         : "off-" + $(v).data("id") + "-sp.svg"),
//   });
// });

loader.load().then(function (google) {
  var latlng =
    768 <= $(window).width()
      ? new google.maps.LatLng(33.591151, 130.3985624)
      : new google.maps.LatLng(33.591151, 130.3985624);
  var featureMap = new google.maps.Map(document.getElementById("featureMap"), {
    mapId: "7d618a5ef86caebb",
    center: latlng,
    zoom: 768 <= $(window).width() ? 16.4 : 14.8,
    scrollwheel: false,
    streetViewControl: false,
    mapTypeControl: false,
  });
  // マーカー毎の処理
  for (var i = 0; i < featureMarkerData.length; i++) {
    const markerLatLng = new google.maps.LatLng({
      lat: featureMarkerData[i]["lat"],
      lng: featureMarkerData[i]["lng"],
    }); // 緯度経度のデータ作成
    featureMarker[i] = new google.maps.Marker({
      position: markerLatLng, // マーカーを立てる位置を指定
      map: featureMap, // マーカーを立てる地図を指定
      icon: {
        url: featureMarkerData[i]["icon"], // マーカーの画像を変更
      },
    });
    featureMarkerEvent(i); // マーカーにクリックイベントを追加
  }
});

loader.load().then(function (google2) {
  var latlng =
    768 <= $(window).width()
      ? new google2.maps.LatLng(33.591151, 130.3985624)
      : new google2.maps.LatLng(33.591151, 130.3985624);
  var pastMap = new google2.maps.Map(document.getElementById("pastMap"), {
    mapId: "7d618a5ef86caebb",
    center: latlng,
    zoom: 768 <= $(window).width() ? 16.4 : 14.8,
    scrollwheel: false,
    streetViewControl: false,
    mapTypeControl: false,
  });
  // マーカー毎の処理
  for (var i = 0; i < pastMarkerData.length; i++) {
    const markerLatLng = new google2.maps.LatLng({
      lat: pastMarkerData[i]["lat"],
      lng: pastMarkerData[i]["lng"],
    }); // 緯度経度のデータ作成
    pastMarker[i] = new google2.maps.Marker({
      position: markerLatLng, // マーカーを立てる位置を指定
      map: pastMap, // マーカーを立てる地図を指定
      icon: {
        url: pastMarkerData[i]["icon"], // マーカーの画像を変更
      },
    });
    pastMarkerEvent(i); // マーカーにクリックイベントを追加
  }
});

// マーカーにクリックイベントを追加

const featurePanels = document
  .querySelector(".js-featureMap")
  .querySelectorAll(".top-map-list__item");
// const pastPanels = document
//   .querySelector(".js-pastMap")
//   .querySelectorAll(".top-map-list__item");

function featureMarkerEvent(i) {
  featureMarker[i].addListener("click", function (e) {
    resetIcon(featureMarker,featureMarkerIcon);
    featureMarker[i].setIcon(featureMarkerIcon[i].icon.replace("off", "on"));
    resetIndex(featureMarker);
    featureMarker[i].setZIndex(100);
    resetShow(featurePanels);
    featurePanels[i].classList.add("js-is-show");
  });
}
function pastMarkerEvent(i) {
  pastMarker[i].addListener("click", function () {
    resetIcon(pastMarker,pastMarkerIcon);
    pastMarker[i].setIcon(pastMarkerIcon[i].icon.replace("off", "on"));
    resetIndex(pastMarker);
    pastMarker[i].setZIndex(100);
    // resetShow(pastPanels);
    // pastPanels[i].classList.add("js-is-show");
  });
}

function resetShow(obj) {
  obj.forEach((e) => {
    e.classList.remove("js-is-show");
  });
}
function resetIndex(obj) {
  obj.forEach((e) => {
    e.setZIndex(50);
  });
}
function resetIcon(obj,defaultIcons) {
  obj.forEach((e, i) => {
    e.setIcon(defaultIcons[i].icon);
  });
}
